import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import MaterialTable from "material-table";
import { useSelector } from "react-redux";
import {
    getProductData,
    deleteProductData,
    updateProductData,
} from "../../../../Redux/API/api_ProductMaster";
import { tableOptions } from "../../../Components/CommonComponents/common_components";
import SnackbarCustom from "../../../Components/Snackbar/Snackbar";
import { tableIcons } from "../../../../Utilities/utility";

export default function UserList() {
    const userdetails = useSelector(
        (state) => state.storeUserDetailsReducer.userData
    );
    const UID = useSelector((state) => state.saveUserIdReducer);
    const [open, setOpen] = useState(false);
    const [snackMessage, setSnackMessage] = useState("");
    const [alertType, setAlertType] = useState("");
    const handleSnackOpen = (text, type) => {
        setSnackMessage(text);
        setAlertType(type);
        setOpen(true);
    };
    const handleClose = (e) => {
        setOpen(false);
    };
    function isAlphanumeric(value) {
        const re = /^[(aA-zZ )(0-9)]*$/;
        return re.test(value);
    }
    function isProductExists(value) {
        const obj = tableData.find((c) => c.productName == value);
        return obj ? true : false;
    }
    function isProductExists(value, id) {
        const obj = tableData.find((c) => c.productName == value);
        return obj && obj.productId !== id ? true : false;
    }
    function validateProductName(value, id) {
        return !value
            ? { isValid: false, helperText: "*Required" }
            : !isAlphanumeric(value)
                ? { isValid: false, helperText: "Only alphanumerics" }
                : (!id && isProductExists(value)) || (id && isProductExists(value, id))
                    ? { isValid: false, helperText: "Already exists" }
                    : { isValid: true, helperText: "" };
    }

    var columns = [
        {
            title: "ProductId",
            field: "productId",
            hidden: true,
        },
        {
            title: "Product Name",
            field: "productName",
            validate: (rowData) =>
                validateProductName(rowData.productName, rowData.productId),
        },
    ];
    const [tableData, setTableData] = useState([]);
    const [isLoader, setIsLoader] = useState(false);
    const siteToken = useSelector((state) => state.saveTokenReducer);
    const azureToken = useSelector((state) => state.saveAzureTokenReducer);

    function getTableData() {
        setIsLoader(true);
        getProductData(
            siteToken,
            UID.id,
            userdetails.userEmail,
            userdetails.gid,
            userdetails.roleName,
            userdetails.roleId,
            azureToken.token
        )
            .then((response) => {
                setTableData(response);
                setIsLoader(false);
            })
            .catch((error) => {
                handleSnackOpen("Error : " + error, "error");
                setIsLoader(false);
            });
    }
    const enterKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
        }
    };
    useEffect(() => {
        document.addEventListener("keydown", enterKeyDown);

        getTableData();

        return () => {
            document.removeEventListener("keydown", enterKeyDown);
        };
    }, [userdetails]);

    const handleRowUpdate = (newTableData, oldTableData, resolve, reject) => {
        setIsLoader(true);
        newTableData.loggedinUserId = userdetails.userId;
        updateProductData(
            siteToken,
            azureToken.token,
            UID.id,
            userdetails.userEmail,
            userdetails.gid,
            userdetails.roleName,
            userdetails.roleId,
            newTableData

        )
            .then((response) => {
                if (response.response) {
                    handleSnackOpen(response.responseMsg, "success");
                    resolve();
                    setIsLoader(false);
                    getTableData();
                } else {
                    handleSnackOpen(response.responseMsg, "error");
                    reject();
                    setIsLoader(false);
                }
            })
            .catch((error) => {
                handleSnackOpen("Exception : " + error, "error");
                reject();
                setIsLoader(false);
            });
    };
    const handleRowDelete = (oldTableData, resolve, reject) => {
        setIsLoader(true);
        oldTableData.loggedinUserId = userdetails.userId;
        deleteProductData(
            siteToken,
            azureToken.token,
            UID.id,
            userdetails.userEmail,
            userdetails.gid,
            userdetails.roleName,
            userdetails.roleId,
            oldTableData
           
        )
            .then((response) => {
                if (response.response) {
                    handleSnackOpen(response.responseMsg, "success");
                    resolve();
                    setIsLoader(false);
                    getTableData();
                } else {
                    handleSnackOpen(response.responseMsg, "error");
                    reject();
                    setIsLoader(false);
                }
            })
            .catch((error) => {
                handleSnackOpen("Exception : " + error, "error");
                reject();
                setIsLoader(false);
            });
    };
    function getDisableTooltip(value, type) {
        return value === true
            ? "Product already associated with live production orders"
            : type === "Edit"
                ? "Edit"
                : "Delete";
    }
    return (
        <div>
            <div className="App">
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <MaterialTable
                            title=""
                            columns={columns}
                            data={tableData}
                            icons={tableIcons}
                            isLoading={isLoader}
                            options={tableOptions}
                            editable={{
                                isEditable: (rowData) => !rowData.isreadonlyProduct,
                                editTooltip: (rowData) =>
                                    getDisableTooltip(rowData.isreadonlyProduct, "Edit"),
                                isDeletable: (rowData) => !rowData.isreadonlyProduct,
                                deleteTooltip: (rowData) =>
                                    getDisableTooltip(rowData.isreadonlyProduct, "Delete"),
                                onRowUpdate: (newTableData, oldTableData) =>
                                    new Promise((resolve, reject) => {
                                        handleRowUpdate(
                                            newTableData,
                                            oldTableData,
                                            resolve,
                                            reject
                                        );
                                    }),
                            }}
                        />
                    </Grid>
                </Grid>
                <>
                    <SnackbarCustom
                        open={open}
                        message={snackMessage}
                        alertType={alertType}
                        handleClose={handleClose}
                    />
                </>
            </div>
        </div>
    );
}
